import React from 'react'
import { getAPIFullUrl, getAxiosConfig, getUserAPIToken } from './risapi';
import { risapi } from './risapi';



export const createRole =  async (newRole,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        
        const response = await risapi.post('/api/roles', newRole,getAxiosConfig());

        console.log("create Role Response",response);
        
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const UpdateRole =  async (editRole,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        editRole._method = 'put';
        const response = await risapi.post('/api/roles/'+editRole.id, editRole,getAxiosConfig());

        console.log(response);
        
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const destroyRole =  async (deleteRole,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        deleteRole._method = 'delete';
        const response = await risapi.post('/api/roles/'+deleteRole.id, deleteRole,getAxiosConfig());

        console.log(response);
        
        if (response.status === 204) {
            callback({role:deleteRole});
        }
    } catch (error) {
        callback(error);
    }
}

export const getRoles = async(filterParameters,callback)=>{
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        
        //         "Authorization": "Bearer " + getAxiosConfig()
        const response = await risapi.get(getAPIFullUrl('/api/roles', filterParameters),getAxiosConfig());

            console.log("getdistrict response",response);
            
        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}

export const fetchRole = async(districtId,callback)=>{
    try {
     
        const response = await risapi.get('/api/roles/'+districtId,getAxiosConfig());


        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}


export const destroyRolesMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/roles/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({role:ids});
        }
    } catch (error) {
        callback(error);
    }
}


